import React, { useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import JwtAuthService from "services/JwtAuthService";
import { signOutSuccess } from "redux/actions/Auth";
import SplashScreen from "components/shared-components/SplashScreen";

const SESSION_CHECK_TIMEOUT = 15000;

/**
 * Holds routing behind the splash screen until a persisted session has been
 * confirmed with the backend, so a stale session never renders the app layout.
 */
const SessionGate = ({ children }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const [checking, setChecking] = useState(() => Boolean(store.getState().auth.token));

  useEffect(() => {
    if (!checking) return;
    JwtAuthService.refreshToken({ timeout: SESSION_CHECK_TIMEOUT })
      .catch((error) => {
        // Only a 401 means the session is gone; a network/server error shouldn't log the user out.
        if (error?.response?.status === 401) {
          dispatch(signOutSuccess());
        }
      })
      .finally(() => setChecking(false));
  }, [checking, dispatch]);

  return checking ? <SplashScreen /> : children;
};

export default SessionGate;
